const DRAFT_PREFIX = "flownect:chat-draft:";

export type ChatDraftScope = "sms" | "internal" | "group" | "job";

interface BuildChatDraftKeyParams {
  companyId?: number | string | null;
  scope: ChatDraftScope;
  id?: number | string | null;
  subType?: string | null;
}

export const buildChatDraftKey = ({ companyId, scope, id, subType }: BuildChatDraftKeyParams): string | null => {
  if (id == null || id === "") return null;

  const company = companyId == null || companyId === "" ? "no-company" : String(companyId);
  const target = subType ? `${subType}:${id}` : String(id);

  return `${DRAFT_PREFIX}${company}:${scope}:${target}`;
};

export const getChatDraft = (draftKey?: string | null): string => {
  if (!draftKey) return "";

  try {
    return sessionStorage.getItem(draftKey) ?? "";
  } catch {
    return "";
  }
};

export const setChatDraft = (draftKey: string | null | undefined, value: string): void => {
  if (!draftKey) return;

  try {
    if (value) sessionStorage.setItem(draftKey, value);
    else sessionStorage.removeItem(draftKey);
  } catch {
    // sessionStorage can be unavailable (private mode) or full; drafts are best-effort.
  }
};

export const clearChatDraft = (draftKey?: string | null): void => {
  if (!draftKey) return;

  try {
    sessionStorage.removeItem(draftKey);
  } catch {
    // no-op
  }
};

export const clearAllChatDrafts = (): void => {
  try {
    const keys: string[] = [];

    for (let index = 0; index < sessionStorage.length; index += 1) {
      const key = sessionStorage.key(index);
      if (key?.startsWith(DRAFT_PREFIX)) keys.push(key);
    }

    keys.forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // no-op
  }
};
